import Router from "./router";
import { Container, GlobalStyle } from "./global/styles";
import { ThemeProvider } from "@zendeskgarden/react-theming";
import { ToastProvider } from "@zendeskgarden/react-notifications";
import { ConfigGate } from "./components/configGate";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const App = () => {

    return (
        <ThemeProvider>
            <ToastProvider>
                <QueryClientProvider client={queryClient}>
                    <GlobalStyle />
                    <Container>
                        <ConfigGate>
                            <Router />
                        </ConfigGate>
                    </Container>
                </QueryClientProvider>
            </ToastProvider>
        </ThemeProvider>
    )
}

export default App;
